"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var modules_1 = require("./modules");
exports.default = {
    PERFORMANCE_OVERVIEW_EXPORT: [
        {
            entitlement: "B2B2024_ComponentPerformanceOverviewExport",
        },
        {
            entitlement: "B2B_StatsAnalyze",
        },
        {
            entitlement: "B2B_StatsInvitationConversion",
        },
        {
            entitlement: "B2B_StatsGoogleSearch",
        },
    ],
    TRUSTSCORE_INSIGHTS: [
        {
            entitlement: "B2B2024_PageTrustscoreInsights",
        },
        {
            launchDarkly: "b2b-statisticsapp-trustscoreinsights",
        },
    ],
    SERVICE_REVIEWS_PAGE: [
        {
            entitlement: "B2B2024_PageServiceReviews",
        },
        {
            entitlement: "B2B_StatsAnalyze",
        },
    ],
    SERVICE_REVIEWS_TAG_REPORT_TABLE: [
        {
            entitlement: "B2B2024_ComponentServiceReviewsTagReportTable",
        },
        {
            entitlement: "B2B_StatsAnalyze",
        },
    ],
    SERVICE_REVIEWS_TOPICS_FILTER: __spreadArray(__spreadArray([], __read(modules_1.legacyReviewInsightsModuleAccess), false), [
        {
            entitlement: "B2B2024_ComponentServiceReviewsTopicsFilter",
        },
    ], false),
    REPLY_DATA_PAGE: [
        {
            entitlement: "B2B2024_PageReplyData",
        },
        {
            entitlement: "B2B_EngagementAnalytics",
        },
    ],
    ORGANIC_REACH_PAGE: [
        {
            entitlement: "B2B2024_PageOrganicReach",
        },
        {
            entitlement: "B2B_StatsGoogleSearch",
        },
    ],
    INVITATION_CONVERSION_PAGE: [
        {
            entitlement: "B2B2024_PageInvitationConversion",
        },
        {
            entitlement: "B2B_StatsInvitationConversion",
        },
    ],
    TEMPLATE_COMPARISON_PAGE: [
        {
            entitlement: "B2B2024_PageTemplateComparison",
        },
        {
            entitlement: "B2B_StatsInvitationConversion",
        },
    ],
    BENCHMARKING_PAGE_REDIRECT: [
        {
            entitlement: "B2B2024_AppReviewInsights",
        },
    ],
};
//# sourceMappingURL=performance.js.map